// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.5.2 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/plugins/v1/manifest.proto (package mochabugapis.adapt.plugins.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { ServiceBinding, ServiceBindingJson } from "./service_binding_pb";
import { file_mochabugapis_adapt_plugins_v1_service_binding } from "./service_binding_pb";
import type { ServiceDefinition, ServiceDefinitionJson } from "./service_definition_pb";
import { file_mochabugapis_adapt_plugins_v1_service_definition } from "./service_definition_pb";
import type { Vertex, VertexJson } from "./vertex_pb";
import { file_mochabugapis_adapt_plugins_v1_vertex } from "./vertex_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/plugins/v1/manifest.proto.
 */
export const file_mochabugapis_adapt_plugins_v1_manifest: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_mochabugapis_adapt_plugins_v1_service_binding, file_mochabugapis_adapt_plugins_v1_service_definition, file_mochabugapis_adapt_plugins_v1_vertex]);

/**
 * Manifest describes a plugin and its properties.
 *
 * Security considerations: The platform ensures that secrets and certificates
 * are stored and transmitted securely.
 *
 * *** Plugin authors must also ensure that their implementations
 * handle sensitive data appropriately! ***
 *
 * @generated from message mochabugapis.adapt.plugins.v1.Manifest
 */
export type Manifest = Message<"mochabugapis.adapt.plugins.v1.Manifest"> & {
  /**
   * 'name' is the alpha-numeric identifier of the plugin. Must be conform to a ES variable name
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 'version' is the plugin's version, following SemVer 2.0: https://semver.org/
   *
   * @generated from field: string version = 2;
   */
  version: string;

  /**
   * 'label' is a human-friendly label displayed in the UI.
   *
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * 'description' is a short, human-friendly description displayed in the UI.
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * 'organization' is the id of the organization the user belongs to.
   *
   * @generated from field: string organization = 5;
   */
  organization: string;

  /**
   * 'homepage' is the plugin's homepage URL.
   *
   * @generated from field: optional string homepage = 6;
   */
  homepage?: string;

  /**
   * 'repository' is the plugin's repository URL.
   *
   * @generated from field: optional string repository = 7;
   */
  repository?: string;

  /**
   * 'bugs' is the URL or email for reporting bugs.
   *
   * @generated from field: optional string bugs = 8;
   */
  bugs?: string;

  /**
   * 'author' is the name of the plugin's author.
   *
   * @generated from field: optional string author = 9;
   */
  author?: string;

  /**
   * 'logo' is an optional path to the plugin logo.
   * The logo will be resized to a maximum of 80x80 pixels.
   * - Supported file formats:
   *   - GIF: .gif
   *   - JPEG: .jpg, .jpeg, .jfif, .pjpeg, .pjp
   *   - PNG: .png
   *   - SVG: .svg
   *   - WEBP: .webp
   *   - AVIF: .avif
   *
   * @generated from field: optional string logo = 10;
   */
  logo?: string;

  /**
   * 'vertices' is a list of vertices that constitute the plugin.
   * this is filled in automatically when configurating a project on the filesystem
   *
   * @generated from field: repeated mochabugapis.adapt.plugins.v1.Vertex vertices = 11;
   */
  vertices: Vertex[];

  /**
   * 'service_definitions' are the actual definition of services that may be referenced
   * on either a system level, or user level at the vertices
   *
   * @generated from field: repeated mochabugapis.adapt.plugins.v1.ServiceDefinition service_definitions = 12;
   */
  serviceDefinitions: ServiceDefinition[];

  /**
   * 'system_services' are the services that are available on a system level
   * that is, configured and used by the plugin for exclusive purposes
   * IMPORTANT: any binding referring to a grant-type CODE will be required
   * to have the same name as the system_definition and be required to be of service type
   *
   * @generated from field: repeated mochabugapis.adapt.plugins.v1.ServiceBinding system_services = 13;
   */
  systemServices: ServiceBinding[];
};

/**
 * Manifest describes a plugin and its properties.
 *
 * Security considerations: The platform ensures that secrets and certificates
 * are stored and transmitted securely.
 *
 * *** Plugin authors must also ensure that their implementations
 * handle sensitive data appropriately! ***
 *
 * @generated from message mochabugapis.adapt.plugins.v1.Manifest
 */
export type ManifestJson = {
  /**
   * 'name' is the alpha-numeric identifier of the plugin. Must be conform to a ES variable name
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * 'version' is the plugin's version, following SemVer 2.0: https://semver.org/
   *
   * @generated from field: string version = 2;
   */
  version?: string;

  /**
   * 'label' is a human-friendly label displayed in the UI.
   *
   * @generated from field: string label = 3;
   */
  label?: string;

  /**
   * 'description' is a short, human-friendly description displayed in the UI.
   *
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * 'organization' is the id of the organization the user belongs to.
   *
   * @generated from field: string organization = 5;
   */
  organization?: string;

  /**
   * 'homepage' is the plugin's homepage URL.
   *
   * @generated from field: optional string homepage = 6;
   */
  homepage?: string;

  /**
   * 'repository' is the plugin's repository URL.
   *
   * @generated from field: optional string repository = 7;
   */
  repository?: string;

  /**
   * 'bugs' is the URL or email for reporting bugs.
   *
   * @generated from field: optional string bugs = 8;
   */
  bugs?: string;

  /**
   * 'author' is the name of the plugin's author.
   *
   * @generated from field: optional string author = 9;
   */
  author?: string;

  /**
   * 'logo' is an optional path to the plugin logo.
   * The logo will be resized to a maximum of 80x80 pixels.
   * - Supported file formats:
   *   - GIF: .gif
   *   - JPEG: .jpg, .jpeg, .jfif, .pjpeg, .pjp
   *   - PNG: .png
   *   - SVG: .svg
   *   - WEBP: .webp
   *   - AVIF: .avif
   *
   * @generated from field: optional string logo = 10;
   */
  logo?: string;

  /**
   * 'vertices' is a list of vertices that constitute the plugin.
   * this is filled in automatically when configurating a project on the filesystem
   *
   * @generated from field: repeated mochabugapis.adapt.plugins.v1.Vertex vertices = 11;
   */
  vertices?: VertexJson[];

  /**
   * 'service_definitions' are the actual definition of services that may be referenced
   * on either a system level, or user level at the vertices
   *
   * @generated from field: repeated mochabugapis.adapt.plugins.v1.ServiceDefinition service_definitions = 12;
   */
  serviceDefinitions?: ServiceDefinitionJson[];

  /**
   * 'system_services' are the services that are available on a system level
   * that is, configured and used by the plugin for exclusive purposes
   * IMPORTANT: any binding referring to a grant-type CODE will be required
   * to have the same name as the system_definition and be required to be of service type
   *
   * @generated from field: repeated mochabugapis.adapt.plugins.v1.ServiceBinding system_services = 13;
   */
  systemServices?: ServiceBindingJson[];
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.Manifest.
 * Use `create(ManifestSchema)` to create a new message.
 */
export const ManifestSchema: GenMessage<Manifest, {jsonType: ManifestJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_manifest, 0);

